import type { GridValueGetterParams } from '@mui/x-data-grid-pro'

export function getValue(params: GridValueGetterParams) {
  const fieldName = params.field.replace('formattedData.', '')
  return params.row[fieldName]
}
